export default "__VITE_ASSET__Bb9JII_n__"